import { DatasourceDomain } from '@mode/shared/contract-common';
import { createAction, props } from '@ngrx/store';

export const loadDatasources = createAction('[Datasource] Load Datasources');

export const loadDatasourcesSuccess = createAction(
  '[Datasource] Load Datasources Success',
  props<{ datasources: ReadonlyArray<DatasourceDomain.Datasource> }>()
);

export const loadDatasourcesFailure = createAction('[Datasource] Load Datasources Failure', props<{ error: any }>());

export const loadReportDatasources = createAction('[Report Details] Load Report Datasources');

export const loadReportDatasourcesSuccess = createAction(
  '[Report Details] Load Report Datasources Success',
  props<{ datasources: ReadonlyArray<DatasourceDomain.Datasource> }>()
);

export const loadReportDatasourcesFailure = createAction(
  '[Report Details] Load Report Datasources Failure',
  props<{ error: any }>()
);

export const refreshDatasource = createAction('[Report Editor] Refresh Datasource', props<{ token: string }>());

export const refreshDatasourceSuccess = createAction(
  '[Report Editor] Refresh Datasource Success',
  props<{ token: string }>()
);

export const refreshDatasourceFailure = createAction(
  '[Report Editor] Refresh Datasource Failure',
  props<{ error: any; token: string }>()
);
